<div class="hexagon" id="{{'rank' + rank}}">
  <div class="rank"> {{rank}}</div>
</div>
